import { render, staticRenderFns } from "./BusinessUnitSwitcherModal.vue?vue&type=template&id=1c78e8be&scoped=true&lang=pug&"
import script from "./BusinessUnitSwitcherModal.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitSwitcherModal.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitSwitcherModal.vue?vue&type=style&index=0&id=1c78e8be&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c78e8be",
  null
  
)

export default component.exports